import { render } from "./JournalEntryReview.vue?vue&type=template&id=48cd387e&scoped=true"
import script from "./JournalEntryReview.vue?vue&type=script&lang=js"
export * from "./JournalEntryReview.vue?vue&type=script&lang=js"

import "./JournalEntryReview.vue?vue&type=style&index=0&id=48cd387e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cd387e"]])

export default __exports__